import { buildStreamingMarkdownText } from '@/domains/profile/components/user-profile/analysis/utils';
import { INLINE_HANDLE_WITH_TIGHT_COLON_PATTERN } from '@/lib/utils/regex';

const INLINE_HANDLE_WITH_TIGHT_COLON = INLINE_HANDLE_WITH_TIGHT_COLON_PATTERN;

// Historically this helper inserted hard line breaks after handle anchors. We now keep the name for
// backwards compatibility but repurpose it to normalize summarizer markdown so it flows through the
// shared Streamdown stack. That includes fixing handle-colon spacing and linking tweet/user refs.
export function addLineBreakAfterHandleAnchors(input: string): string {
  if (!input) {
    return input;
  }

  const withHandleSpacing = String(input).replaceAll(
    INLINE_HANDLE_WITH_TIGHT_COLON,
    (_match, handle, colon) => `${handle}${colon} `
  );

  return buildStreamingMarkdownText(withHandleSpacing);
}
